import React from "react";
import { toast } from "react-toastify";

const AssignModal = ({
  isOpen,
  onClose,
  selectedProduct,
  actionType,
  staffID,
  setStaffID,
  staffList,
  approvingAuthority,
  setApprovingAuthority,
  expectedReturnDate,
  setExpectedReturnDate,
  initialCondition,
  setInitialCondition,
  reasonForAcquisition,
  setReasonForAcquisition,
  onSubmit,
  loading,
  error,
}) => {
  if (!isOpen) return null;

  const approvingAuthorities = [
    "Baaba Abban",
    "Ernie Ofori",
    "Kwame Grundow",
    "Christopher Hanson",
  ];

  const handleSubmit = () => {
    if (
      !staffID ||
      !approvingAuthority ||
      !expectedReturnDate ||
      !initialCondition ||
      !reasonForAcquisition
    ) {
      toast.error(
        `Please fill in all required fields${
          actionType === "reassign" ? " for reassignment" : ""
        }.`
      );
      return;
    }
    onSubmit();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="relative bg-white w-[95%] sm:w-[600px] max-h-[95vh] overflow-y-auto rounded-xl p-6 shadow-lg">
        <button
          className="absolute top-3 right-4 text-gray-500 hover:text-red-500 text-2xl"
          onClick={onClose}
        >
          &times;
        </button>

        <h2 className="text-xl sm:text-2xl font-semibold mb-4 text-center">
          {actionType === "reassign" ? "Reassign Asset" : "Assign Asset"}
        </h2>

        <p className="text-sm text-gray-600 mb-4 text-center">
          {actionType === "reassign"
            ? `Reassigning ${selectedProduct?.asset_name} with ID:`
            : `Assigning ${selectedProduct?.asset_name} with  ID:`}{" "}
          <span className="font-medium text-black">
            {selectedProduct?.iridis_id}
          </span>
        </p>

        {error && (
          <div className="bg-red-100 text-red-700 p-3 rounded-md mb-4 text-sm">
            <strong>Error:</strong> {error}
          </div>
        )}

        {loading ? (
          <div className="flex flex-col items-center gap-3 py-10">
            <p className="text-gray-700 font-medium">
              {actionType === "reassign"
                ? "Reassigning Asset..."
                : "Assigning Asset..."}
            </p>
            <div className="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
          </div>
        ) : (
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Staff ID:
              </label>
              <select
                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={staffID}
                onChange={(e) => setStaffID(e.target.value)}
              >
                <option value="">Select Staff ID</option>
                {staffList.map((staff) => (
                  <option key={staff.staff_id} value={staff.staff_id}>
                    {staff.staff_id} - {staff.staff_name}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Approving Authority:
              </label>
              <select
                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={approvingAuthority}
                onChange={(e) => setApprovingAuthority(e.target.value)}
              >
                <option value="">Select Approving Authority</option>
                {approvingAuthorities.map((authority) => (
                  <option key={authority} value={authority}>
                    {authority}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Expected Return Date:
              </label>
              <input
                type="date"
                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={expectedReturnDate}
                onChange={(e) => setExpectedReturnDate(e.target.value)}
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Initial Condition:
              </label>
              <select
                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={initialCondition}
                onChange={(e) => setInitialCondition(e.target.value)}
              >
                <option value="---">Select Condition</option>
                {actionType === "assign" && (
                  <option value="brand new">Brand New</option>
                )}
                <option value="excellent">Excellent</option>
                <option value="used">Used</option>
                <option value="poor">Poor</option>
                <option value="damaged">Damaged</option>
                <option value="needs-repair">Needs Repair</option>
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Reason for Acquisition:
              </label>
              <input
                type="text"
                className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={reasonForAcquisition}
                onChange={(e) => setReasonForAcquisition(e.target.value)}
              />
            </div>

            <div className="pt-4 flex justify-center">
              <button
                className="bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-400"
                onClick={handleSubmit}
              >
                {actionType === "reassign" ? "Reassign" : "Assign"}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AssignModal;
